<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div id="text">排班管理列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small" icon='md-add'>新增</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增排班管理' : '编辑排班管理'"
      footer-hide
      width="700"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="车牌号" prop="carNo">
              <selectCar :name="item.carNo" @update:name="item.carNo = $event">
              </selectCar>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="项目名称" prop="groupId">
              <selectItems
                :name="item.groupName"
                @update:name="item.groupName = $event"
                :id="item.groupId"
                @update:id="item.groupId = $event"
              ></selectItems>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="所属部门" prop="deptName">
              <selectGroup
                :name="item.deptName"
                @update:name="item.deptName = $event"
                :id="item.deptId"
                @update:id="item.deptId = $event"
              >
              </selectGroup>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="负责人" prop="manager">
              <Input v-model="item.manager" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="电话" prop="tel">
              <Input v-model="item.tel" placeholder="请输入"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="next('item')">下一步</Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <classesList
      :classesList="item.classesList"
      @classesLis="addUpdate"
      ref="classesList"
    ></classesList>
  </div>
</template>
<script>
import axios from "axios";
import classesList from "./classesList.vue";
export default {
  components: { classesList },
  data() {
    return {
      openForm: false,

      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "项目名称",
          key: "groupName",
        },
        {
          title: "所属部门",
          key: "deptName",
        },
        {
          title: "负责人",
          key: "manager",
        },
        {
          title: "电话",
          key: "tel",
        },
        {
          title: "创建者账号",
          key: "createAccount",
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: 6,
        groupName: "",
        deptId: 6,
        deptName: "",
        lineId: 1,
        carNo: "",
        classesList: [{ startTime: "9:00", endTime: "10:00" }],
        dddd: [
          { carNo: "1111", classesList: [{ startTime: "9:00", endTime: "10:00" }] },
          { carNo: "2222", classesList: [{ startTime: "9:00", endTime: "10:00" }] },
        ],
        manager: "",
        tel: "",
      },
      ruleValidate: {
        carNo: { required: true, message: "必填" },
        groupId: { required: true, message: "必填" },
        deptName: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.mwm + "/schedule/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        this.tableData = data;
      });
    },
    next(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.openForm = false;
          this.$refs.classesList.open();
        }
      });
    },
    addUpdate(v) {
      console.log(v);
      this.item.classesList = v;
      if (this.isAdd) {
        axios({
          method: "post",
          url: axios.mwm + "/schedule/add",
          data: this.item,
        }).then((res) => {
          if (res.data.code != 200) {
            this.$Message.error(res.data.message);
          } else {
            this.openForm = false;
            this.$refs.classesList.close();
            this.getList();
          }
        });
      } else {
        axios({
          method: "post",
          url: axios.mwm + "/schedule/update",
          data: this.item,
        }).then((res) => {
          if (res.data.code != 200) {
            this.$Message.error(res.data.message);
          } else {
            this.openForm = false;
            this.$refs.classesList.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.mwm + "/schedule/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.openForm = false;
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/carsys/pbgl.vue